<script>
  import { onMount } from 'svelte';
  import { Link, navigate } from 'svelte-routing';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import { getRelativeTime } from '../utils';

  let questions = [];
  let isEnabled = true;
  let isLoading = true;
  let currentUser;
  authStore.subscribe(v => currentUser = v.user);

  onMount(async () => {
    const s = await fetch(getApiUrl('/qa/status')).then(r => r.json());
    isEnabled = s.enabled;
    if(isEnabled) {
        const res = await fetch(getApiUrl('/qa/questions'));
        questions = await res.json();
    }
    isLoading = false;
  });

  function goAsk() {
      if(!currentUser) return alert("Please log in.");
      navigate('/qa/ask');
  }
</script>

<div class="container">
    <div class="header">
        <h2>Community Q&A</h2>
        {#if isEnabled}<button class="ask-btn" on:click={goAsk}>Ask Question (10 Credits)</button>{/if}
    </div>

    {#if !isEnabled}
        <div class="alert">Q&A is currently disabled.</div>
    {:else if isLoading}
        <p>Loading...</p>
    {:else if questions.length === 0}
        <p>No questions yet. Be the first!</p>
    {:else}
        <div class="list">
            {#each questions as q}
                <Link to={`/qa/questions/${q._id}`} class="q-card">
                    <div class="q-main">
                        <h3>{q.title}</h3>
                        <div class="meta">
                            <span>By {q.userName}</span> • <span>{getRelativeTime(q.createdAt)}</span>
                        </div>
                    </div>
                    <div class="q-stat">
                        <span class="status {q.status.toLowerCase()}">{q.status}</span>
                        <span class="views">{q.views} views</span>
                    </div>
                </Link>
            {/each}
        </div>
    {/if}
</div>

<style>
    .container { max-width: 900px; margin: 2rem auto; padding: 1rem; }
    .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem; }
    .ask-btn { background: #007bff; color: white; border: none; padding: 0.7rem 1.2rem; border-radius: 4px; cursor: pointer; }
    .list { display: flex; flex-direction: column; gap: 1rem; }
    .q-card { background: white; padding: 1.5rem; border: 1px solid #eee; border-radius: 8px; text-decoration: none; color: inherit; display: flex; justify-content: space-between; align-items: center; transition: transform 0.1s; }
    .q-card:hover { transform: translateY(-2px); box-shadow: 0 4px 6px rgba(0,0,0,0.05); }
    h3 { margin: 0 0 0.5rem 0; color: #0056b3; }
    .meta { color: #666; font-size: 0.85rem; }
    .q-stat { text-align: right; display: flex; flex-direction: column; gap: 0.5rem; }
    .status { font-weight: bold; font-size: 0.8rem; padding: 2px 8px; border-radius: 10px; }
    .status.open { background: #e3f2fd; color: #0d47a1; }
    .status.solved { background: #e8f5e9; color: #2e7d32; }
    .views { font-size: 0.8rem; color: #888; }
    .alert { background: #fff3cd; padding: 1rem; border-radius: 4px; text-align: center; }
</style>